import { MenuList as MuiMenuList, styled } from "@mui/material";
import { timePickerName } from "../classes.js";
const MenuList = styled(MuiMenuList, {
  name: timePickerName,
  slot: "MenuList",
  overridesResolver: (_props, styles) => styles.menuList
})(() => ({
  maxHeight: 300,
  overflowX: "hidden",
  overflowY: "scroll",
  pointerEvents: "all"
}));
export {
  MenuList
};
//# sourceMappingURL=MenuList.js.map
